import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { FinishedProductModel } from '../../../../@models/erp/finishedProduct';

@Component({
  selector: 'ngx-unit-selector-renderer',
  template: `
    <span class="unit-link" (click)="open()">
      Open Units
    </span>

    <!-- <nrk-window #win>
      <nrk-content style="margin:1rem">
        <ngx-unit-converter
          *ngIf="rowData"
          [finishedProduct]="finishedProduct"
          [price]="rowData"
          (priceChange)="onPriceChange($event)">
        </ngx-unit-converter>
      </nrk-content>
    </nrk-window> -->
  `,
  styles: [`
    .unit-link {
      cursor: pointer;
      color: #3366ff;
      text-decoration: underline;
    }
  `]
})
export class UnitSelectorRendererComponent implements ViewCell {

  value: any;
  rowData: any;

  @Output() openRequested = new EventEmitter<any>();


  // @ViewChild('win') win: any;

  open() {
    // console.log('Finished product:', this.finishedProduct);
    // console.log('Row data:', this.rowData);
    // this.win.show();
    this.openRequested.emit(this.rowData);
  }

  // onPriceChange(event: any) {
  //   this.rowData.value = event;
  // }
}
